import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import InputLabel from '@mui/material/InputLabel';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Alert from '@mui/material/Alert';
import visuallyHidden from '@mui/utils/visuallyHidden';
import {marketingInterest} from "../apis/junkyard";
import {MarketingInterestRequest, MarketingInterestResponse} from '../utils/types';
import orangeTrieLogoWithWordMark from '../images/orange_trie_logo_with_wordmark.svg';


export function ComingSoon() {
  const [email, setEmail] = React.useState('');
  const [isLoading, setIsLoading] = React.useState(false);
  const [message, setMessage] = React.useState({ type: '', text: '' });

  const handleMarketingInterestSignUp = async () => {
    if (!email || !email.includes('@')) {
      setMessage({ type: 'error', text: 'Please enter a valid email address' });
      return;
    }

    setIsLoading(true);
    setMessage({ type: '', text: '' });

    try {
      let response: MarketingInterestResponse = await marketingInterest({
        email: email
      } as MarketingInterestRequest)
      if (response.status === "success")
        setMessage({ type: 'info', text: 'Successfully registered!' });
    } catch (error) {
      console.error('Error signing up:', error);
      setMessage({ type: 'error', text: 'Something went wrong. Please try again.' });
    } finally {
      setIsLoading(false);
    }
  };

  const handleEmailChange = (event: { target: { value: React.SetStateAction<string>; }; }) => {
    setEmail(event.target.value);
    // Clear any previous messages when user starts typing
    if (message.text) {
      setMessage({ type: '', text: '' });
    }
  };

  const handleKeyPress = (event: { key: string; }) => {
    if (event.key === 'Enter') {
      handleMarketingInterestSignUp();
    }
  };

  return (
    <Box
      id="hero"
      sx={(theme) => ({
        width: '100%',
        backgroundRepeat: 'no-repeat',

        backgroundImage:
          'radial-gradient(ellipse 80% 50% at 50% -20%, hsl(210, 100%, 90%), transparent)',
        ...theme.applyStyles('dark', {
          backgroundImage:
            'radial-gradient(ellipse 80% 50% at 50% -20%, hsl(210, 100%, 16%), transparent)',
        }),
      })}
    >
      <Container
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          pt: { xs: 14, sm: 20 },
          pb: { xs: 8, sm: 12 },
        }}
      >
        <Stack
          spacing={2}
          useFlexGap
          sx={{ alignItems: 'center', width: { xs: '100%', sm: '70%' } }}
        >
          <Box
            component="img"
            src={orangeTrieLogoWithWordMark}
            alt="Orange Trie — Trade. Test. Triumph. "
            sx={{
              width: '100%',
              maxWidth: { xs: 360, sm: 520, md: 600 },
              height: 'auto',
              display: 'block',
            }}
          />
          <Typography
            sx={{
              textAlign: 'center',
              color: 'text.secondary',
              width: { sm: '100%', md: '80%' },
            }}
          >
            Backtesting for everyone. Now in Beta.
          </Typography>
          <Stack
            direction="column"
            spacing={1}
            useFlexGap
            sx={{ pt: 2, width: { xs: '100%', sm: '350px' } }}
          >
            <InputLabel htmlFor="email-hero" sx={visuallyHidden}>
              Email
            </InputLabel>
            <TextField
              id="email-hero"
              hiddenLabel
              size="small"
              variant="outlined"
              aria-label="Enter your email address"
              placeholder="Your email address"
              fullWidth
              value={email}
              onChange={handleEmailChange}
              onKeyUp={handleKeyPress}
              disabled={isLoading}
              slotProps={{
                htmlInput: {
                  autoComplete: 'off',
                  'aria-label': 'Enter your email address',
                },
              }}
            />
            <Button
              variant={"contained"}
              color="primary"
              size="small"
              sx={{ minWidth: 'fit-content' }}
              onClick={handleMarketingInterestSignUp}
            >
               Subscribe for Updates
            </Button>
          </Stack>

          {message.text && (
            <Alert
              severity={message.type === 'error' ? 'error' : 'success'}
              sx={{ width: { xs: '100%', sm: '350px' } }}
            >
              {message.text}
            </Alert>
          )}

          {/*<Typography*/}
          {/*  variant="caption"*/}
          {/*  color="text.secondary"*/}
          {/*  sx={{ textAlign: 'center' }}*/}
          {/*>*/}
          {/*  By clicking &quot;Sign Up&quot; you agree to our&nbsp;*/}
          {/*  <Link href="#" color="primary">*/}
          {/*    Terms & Conditions*/}
          {/*  </Link>*/}
          {/*  .*/}
          {/*</Typography>*/}
        </Stack>
        {/*<StyledBox id="image" />*/}
      </Container>
    </Box>
  );
}